<div class="tooltip"
    tabindex="0"
    role="button"
    (keydown.enter)="checkMobile()"
    (click)="checkMobile()"
    [attr.aria-labelledby]="id">
    <ng-content></ng-content>
    <span *ngIf="!isMobile" [id]="id" class="content" role="tooltip" [ngClass]="position">{{tooltip}}</span>
</div>
